import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";

@Directive({
  selector: '[appRequireTld]',
  // This part registers the directive as a custom validator
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: RequireTldDirective,
    multi: true
  }]
})
export class RequireTldDirective implements Validator{

  // Add an @Input property.
  // This allows binding a value to 'appRequireTld' from the template.
  // It defaults to 'true' so it works as before if not bound.
  @Input('appRequireTld') isEnabled: boolean = true;
  validate(control: AbstractControl): ValidationErrors | null {
    // First, check if the validation is enabled.
    if (!this.isEnabled) {
      return null; // If not enabled, validation passes.
    }

    const email = control.value as string;

    // Don't validate if there's no value or no '@' symbol
    if (!email || !email.includes('@')) {
      return null; // Let other validators handle this
    }

    const domainPart = email.substring(email.lastIndexOf('@') + 1);

    // If the domain part does NOT have a dot, return an error object
    if (!domainPart.includes('.')) {
      return { missingTld: true }; // Validation failed!
    }

    // If it has a dot, validation passes
    return null;
  }

}
